import type { RouteObject } from 'react-router-dom';
import { lazyWithReload as lazy } from '@/lib/lazyWithReload';
import ManageBookingPage from '../pages/manage-booking/page';

// Public Website Pages
const HomePage = lazy(() => import('../pages/home/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const BookingSuccessPage = lazy(() => import('../pages/booking/success/page'));
const BookingCancelPage = lazy(() => import('../pages/booking/cancel/page'));
const CheckInPage = lazy(() => import('../pages/check-in/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const MembershipsPage = lazy(() => import('../pages/memberships/page'));
const GroupBookingPage = lazy(() => import('../pages/group-booking/page'));
const GroupBookingInvoicePage = lazy(() => import('../pages/group-booking/invoice/page'));
const GroupBookingPaymentPage = lazy(() => import('../pages/group-booking/submit-payment/page'));
const GroupBookingManagePage = lazy(() => import('../pages/group-booking/manage/page'));

// Events Pages
const EventsPage = lazy(() => import('../pages/events/page'));
const EventBookingPage = lazy(() => import('../pages/events/booking/page'));
const EventPaymentEvidencePage = lazy(() => import('../pages/events/submit-payment/page'));

// Error Pages
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  // Public Website Routes
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/search',
    element: <SearchPage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '/manage-booking',
    element: <ManageBookingPage />
  },
  {
    path: '/booking/success',
    element: <BookingSuccessPage />
  },
  {
    path: '/booking/cancel',
    element: <BookingCancelPage />
  },
  {
    path: '/check-in',
    element: <CheckInPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/memberships',
    element: <MembershipsPage />
  },
  {
    path: '/group-booking',
    element: <GroupBookingPage />
  },
  {
    path: '/group-booking/invoice/:ref',
    element: <GroupBookingInvoicePage />
  },
  {
    path: '/group-booking/submit-payment/:ref',
    element: <GroupBookingPaymentPage />
  },
  {
    path: '/group-booking/manage',
    element: <GroupBookingManagePage />
  },

  // Events Routes
  {
    path: '/events',
    element: <EventsPage />
  },
  {
    path: '/events/booking',
    element: <EventBookingPage />
  },
  {
    path: '/events/submit-payment/:number',
    element: <EventPaymentEvidencePage />
  },

  // Error Routes
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
